import { getValidationMessage } from '../messages';
export default {
    requiredField: ({ field })=>getValidationMessage('requiredField', {
            field
        }),
    shouldBeNumber: ({ field })=>getValidationMessage('shouldBeNumber', {
            field
        }),
    shouldBeString: ({ field })=>getValidationMessage('shouldBeString', {
            field
        }),
    stringShouldHaveMinLength: ({ field, minLength })=>getValidationMessage('stringShouldHaveMinLength', {
            field,
            minLength
        }),
    stringShouldHaveMaxLength: ({ field, maxLength })=>getValidationMessage('stringShouldHaveMaxLength', {
            field,
            maxLength
        }),
    stringShouldHaveLength: ({ field, length })=>getValidationMessage('stringShouldHaveLength', {
            field,
            length
        }),
    numberMinValue: ({ field, min })=>getValidationMessage('numberMinValue', {
            field,
            min
        }),
    numberMaxValue: ({ field, max })=>getValidationMessage('numberMaxValue', {
            field,
            max
        }),
    emailShouldContainAt: ()=>getValidationMessage('emailShouldContainAt'),
    emailShouldContainDomain: ()=>getValidationMessage('emailShouldContainDomain'),
    emailShouldHaveValidFormat: ()=>getValidationMessage('emailShouldHaveValidFormat'),
    emailContainsDiacritics: ()=>getValidationMessage('emailContainsDiacritics'),
    incorrectDateInserted: ({ field })=>getValidationMessage('incorrectDateInserted', {
            field
        }),
    incorrectMonthInserted: ({ field })=>getValidationMessage('incorrectMonthInserted', {
            field
        }),
    incorrectYearInserted: ({ field })=>getValidationMessage('incorrectYearInserted', {
            field
        }),
    incorrectDateFormat: ({ field, dateFormats = [
        'dd.mm.rrrr'
    ] })=>getValidationMessage('incorrectDateFormat', {
            field,
            format: dateFormats.join(', ')
        }),
    dateNotBefore: ({ field, before })=>getValidationMessage('dateNotBefore', {
            field,
            before
        }),
    dateNotAfter: ({ field, after })=>getValidationMessage('dateNotAfter', {
            field,
            after
        }),
    birthNumberNotCorrect: ()=>getValidationMessage('birthNumberNotCorrect'),
    birthNumberContainsSlash: ()=>getValidationMessage('birthNumberContainsSlash'),
    icNotCorrect: ()=>getValidationMessage('icNotCorrect'),
    shouldHaveNoWhitespaces: ({ field })=>getValidationMessage('shouldHaveNoWhitespaces', {
            field
        }),
    shouldHaveNoPunctuation: ({ field })=>getValidationMessage('shouldHaveNoPunctuation', {
            field
        }),
    shouldHaveNoPunctuationStrict: ({ field })=>getValidationMessage('shouldHaveNoPunctuationStrict', {
            field
        }),
    shouldHaveOnlyDigits: ({ field })=>getValidationMessage('shouldHaveOnlyDigits', {
            field
        }),
    isAlphanumerical: ({ field })=>getValidationMessage('isAlphanumerical', {
            field
        }),
    companyNameIncorrect: ({ field })=>getValidationMessage('companyNameIncorrect', {
            field
        }),
    phoneIncorrect: ()=>getValidationMessage('phoneIncorrect')
};
